import { BASE_PATH, PATH_BASE_EXTENSION_USER } from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

export async function listApi() {

        const url = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/transaction/`;
        const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
        return axios.get(url, config)
}